import { RumEvent, RumEventDomainContext } from '@datadog/browser-rum';
import { initDatadog } from '@js-boot/datadog-rum';
import { APP_CONFIG } from '../config';
import { isDataDogRumConsentAccepted } from './utils';
import { getDefaultLogger } from '@/utils/logger/logger';

const { dataDogApplicationId, dataDogClientToken, dataDogComponentId, dataDogTeam, stage, version } = APP_CONFIG;

let isDataDogInitialized = false;

const initDatadogRum = async () => {
  if (stage !== 'PRO' || isDataDogInitialized) return;

  const hasDataDogRumConsent = await isDataDogRumConsentAccepted();
  if (!hasDataDogRumConsent) {
    getDefaultLogger().info('DataDog RUM user consent not given, initialization halted.');
    return;
  }

  try {
    await initDatadog({
      applicationId: dataDogApplicationId,
      clientToken: dataDogClientToken,
      componentId: dataDogComponentId,
      team: dataDogTeam,
      version,
      env: stage,
      sessionSampleRate: 100,
      traceSampleRate: 100,
      sessionReplaySampleRate: 10,
      beforeSend,
    });
    isDataDogInitialized = true;
  } catch (error) {
    getDefaultLogger().error('Error during DataDog initialization:', error);
  }
};

const beforeSend = (event: RumEvent, _: RumEventDomainContext) => {
  if (
    (event.type === 'error' && event.error.source === 'report' && event.error.type === 'IgnoredEventCancel') ||
    (event.type === 'error' && event.error.source === 'source' && event.error.message === `Uncaught "Script error."`)
  ) {
    return false;
  }

  return true;
};

export { initDatadogRum, beforeSend };
